import { useQuery } from "@tanstack/react-query";
import { proApi } from "../../lib/api";
import { queryKeys } from "../../lib/query-keys";

export function useProMe(enabled = true) {
	return useQuery({
		queryKey: queryKeys.pro.me(),
		queryFn: async () => {
			const response = await proApi.getMyPro();
			return response.data;
		},
		enabled,
	});
}

export function useProProfile(proId: string | null) {
	return useQuery({
		queryKey: queryKeys.pro.profile(proId ?? ""),
		queryFn: async () => {
			const response = await proApi.getProfile(proId as string);
			return response.data;
		},
		enabled: !!proId,
	});
}

export function useProStats(proId: string | null) {
	return useQuery({
		queryKey: queryKeys.pro.stats(proId ?? ""),
		queryFn: async () => {
			const response = await proApi.getProStats(
				proId as string,
			);
			return response.data;
		},
		enabled: !!proId,
		staleTime: 1000 * 60 * 2, // 2 minutes - stats change less frequently
	});
}
